<template>
  <div
    class="the-banner"
    v-if="banner_info.is_show === 1 && banner_list.length > 0"
  >
    <swiper
      ref="mySwiper"
      class="swiper"
      :options="swiperOption"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(item, index) in banner_list" :key="index">
        <div class="banner-item">
          <img @click="toBannerPath" class="banner-img" :src="item.url" />
        </div>
      </swiper-slide>
      <div hidden class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { encodeSearchParams } from "@/utils/tools";
import api from "@/apis/maintenance-api";
export default {
  name: "Banner",
  components: { Swiper, SwiperSlide },
  data() {
    return {
      banner_list: [], //banner列表
      banner_info: {}, //完整banner响应信息
      extra_params: "", //跳转安心保页面额外参数
      activeIndex: 0, //当前banner索引

      swiperOption: {
        loop: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          // dynamicBullets: true,
        },
        // on: {
        //   slideChangeTransitionEnd: () => {
        //     let timer = setTimeout(() => {

        //       this.activeIndex = swiper ? swiper.activeIndex : 0;
        //       clearTimeout(timer);
        //       this.visitBannerTracking(this.banner_list[this.activeIndex].id);
        //     }, 1000);
        //   },
        // },
      },
      current_exposure_id: null, //当前曝光id，用于点击埋点
    };
  },
  mounted() {
    this.fetchBannerList(); //获取banner列表
  },
  methods: {
    /**
     * 获取banner列表
     * @author 田月荣 <tianyuerong@vchangyi.com>
     */
    async fetchBannerList() {
      this.$loading.show("加载中...");
      try {
        const res = await api.getBannerListApi({
          hash: this.$route.query.scheme_id || this.$route.query.id,
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.banner_info = res.data;
          this.banner_list = res.data.list;
          if (this.banner_list.length > 0) {
            this.visitBannerTracking(this.banner_list[0].id);
          }
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    /**
     * 点击banner埋点
     */
    async clickBannerTracking() {
      const params = {
        exposure_id: this.current_exposure_id,
      };
      try {
        const res = await api.clickBannerTrackingApi(params);
        if (res.code !== 0) {
          console.log("点击悬浮窗埋点异常-response", res);
        }
      } catch (error) {
        console.log("点击悬浮窗埋点失败-error", error);
      }
    },
    /**
     * 曝光Banner埋点
     */
    async visitBannerTracking(banner_id) {
      const params = {
        id: banner_id,
        uuid: localStorage.getItem("OILUSER"),
        hash: this.$route.query.scheme_id || this.$route.query.id,
      };
      try {
        const res = await api.visitBannerTrackingApi(params);
        if (res.code === 0) {
          this.current_exposure_id = res.data.id;
        } else {
          console.log("曝光Banner埋点异常-response", res);
        }
      } catch (error) {
        console.log("曝光Banner埋点失败-error", error);
      }
    },
    /**
     * 点击Banner跳转
     */
    async toBannerPath() {
      await this.clickBannerTracking(); //点击Banner埋点
      // jump_type	int	跳转模块:0-不跳转，1-小程序，2-H5页面，3-其他小程序 4 - 图文
      if (this.banner_list[this.activeIndex].jump_type === 4) {
        this.$router.push({
          path: "/img-detail",
          query: {
            url: this.banner_list[this.activeIndex].content,
          },
        });
        return;
      }
      if (this.banner_list[this.activeIndex].jump_type === 2) {
        this.handleBeforeJump(this.banner_list[this.activeIndex].jump_value);
      }
    },
    /**
     * 跳转H5前的数据处理
     */
    async handleBeforeJump(jump_value) {
      if (jump_value.indexOf("insurance-introduction") === -1) {
        window.location.href = jump_value;
      } else {
        await this.fetchExtraParams();
        if (!this.extra_params) {
          this.$toast.show({
            showTime: 2,
            message: "参数异常",
            style: "error",
          });
          return;
        }
        // console.log(this.extra_params);
        window.location.href = jump_value + "?" + this.extra_params;
      }
    },
    /**
     * 获取安心保落地页所需参数
     */
    async fetchExtraParams() {
      try {
        const res = await api.getLandingExtraParamsApi({
          uuid: localStorage.getItem("OILUSER"),
          hash: this.$route.query.scheme_id || this.$route.query.id,
        });
        if (res.code === 0) {
          this.extra_params = encodeSearchParams(res.data);
        } else {
          console.log("获取安心保落地页所需参数异常-response", res);
        }
      } catch (error) {
        console.log("获取安心保落地页所需参数失败", error);
      }
    },

    onSlideChange() {
      let swiper = this.$refs.mySwiper.$swiper;
      if (this.activeIndex == swiper.realIndex) {
        return;
      }
      this.visitBannerTracking(this.banner_list[swiper.realIndex].id);
      this.activeIndex = swiper.realIndex;
    },
  },
};
</script>
<style lang="less" scoped>
.swiper {
  --swiper-pagination-color: #fad84c; //分页指示器颜色
}
.the-banner {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 160/100rem;
}
.banner-item {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 160/100rem;
  img {
    border-radius: 20/100rem;
    overflow: hidden;
    width: 585/100rem;
    height: 160/100rem;
  }
}
</style>
